import { gql, type ApolloClient } from "@apollo/client";
import type { TrackAnalyticsEventInput } from "@/types/models";

export const STORE_ANALYTICS_QUERY = gql`
  query StoreAnalytics($since: ISO8601DateTime) {
    storeAnalytics(since: $since) {
      storeViews
      productViews
      whatsappClicks
      whatsappProductClicks
      whatsappCartClicks
      topViewedProducts {
        product {
          id
          name
          slug
        }
        viewCount
        clickCount
      }
      topClickedProducts {
        product {
          id
          name
          slug
        }
        viewCount
        clickCount
      }
    }
  }
`;

export const TRACK_ANALYTICS_EVENT = gql`
  mutation TrackAnalyticsEvent($input: TrackAnalyticsEventInput!) {
    trackAnalyticsEvent(input: $input) {
      success
    }
  }
`;

export function storeViewDedupeKey(storeId: string): string {
  return `ws:view:store:${storeId}`;
}

export function productViewDedupeKey(storeId: string, productId: string): string {
  return `ws:view:product:${storeId}:${productId}`;
}

export function trackWhatsAppClick(
  apolloClient: ApolloClient,
  input: TrackAnalyticsEventInput
): void {
  void apolloClient.mutate({
    mutation: TRACK_ANALYTICS_EVENT,
    variables: { input },
  });
}

export function trackStoreViewOnce(apolloClient: ApolloClient, storeId: string): void {
  const key = storeViewDedupeKey(storeId);
  if (sessionStorage.getItem(key)) return;

  sessionStorage.setItem(key, "1");
  void apolloClient.mutate({
    mutation: TRACK_ANALYTICS_EVENT,
    variables: {
      input: {
        storeId,
        eventType: "store_viewed",
      },
    },
  });
}

export function trackProductViewOnce(
  apolloClient: ApolloClient,
  storeId: string,
  productId: string
): void {
  const key = productViewDedupeKey(storeId, productId);
  if (sessionStorage.getItem(key)) return;

  sessionStorage.setItem(key, "1");
  void apolloClient.mutate({
    mutation: TRACK_ANALYTICS_EVENT,
    variables: {
      input: {
        storeId,
        eventType: "product_viewed",
        productId,
      },
    },
  });
}
